import { useResource } from '@landsbankinn/l16n';
import { Button } from '@landsbankinn/ui-kit';
import {
  AllowedLoginType,
  type LoginServerState,
  useApplicationClientContext,
  useApplicationServerContext,
} from '../../../state';
import { res } from './LoginButton.res';

export function LoginButton({
  loginType,
  isLoading,
  fullwidth,
  isValid,
}: {
  loginType: AllowedLoginType;
  isLoading?: boolean;
  fullwidth?: boolean;
  isValid: boolean;
}) {
  const [, clientDispatch] = useApplicationClientContext();
  const { r } = useResource();
  const [serverState] = useApplicationServerContext() as [LoginServerState];

  return (
    <Button
      type="submit"
      onClick={() => {
        if (isValid) {
          clientDispatch({ type: 'clearServerErrorState' });
          clientDispatch({
            type: 'setLoginType',
            payload: { loginType: loginType },
          });
        }
      }}
      isLoading={isLoading}
      width={fullwidth ? '100%' : undefined}
    >
      {serverState.isConsentFlow ? r(res.continue) : r(res.login)}
    </Button>
  );
}
